import { ControlQuestion, CourseThemeDetailed } from '@models/courseTheme'
import { MyCourseChapterTheme } from '@models/myCourse'
import { themeMinutesToFormHours } from '@utils/themeHoursTime'
import { ThemeFormValues } from './types'

type GetDefaultValuesParams = {
  theme?: CourseThemeDetailed
  internalTheme?: MyCourseChapterTheme
  internalCourseMode?: boolean
}

const DEFAULT_CONTROL_QUESTION: ControlQuestion = {
  question: '',
  options: [
    { text: '', isCorrect: true },
    { text: '', isCorrect: false },
    { text: '', isCorrect: false },
  ],
}

const getDefaultValues = ({
  theme,
  internalTheme,
  internalCourseMode,
}: GetDefaultValuesParams): Partial<ThemeFormValues> | undefined => {
  if (internalCourseMode) {
    // Internal course mode
    if (!internalTheme) {
      return { controlQuestion: DEFAULT_CONTROL_QUESTION }
    }

    const result: Partial<ThemeFormValues> = {
      title: internalTheme.title,
      test: internalTheme.test,
      controlQuestion: internalTheme.controlQuestion ?? DEFAULT_CONTROL_QUESTION,
    }

    if (internalTheme.hoursTime) {
      result.hoursTime = themeMinutesToFormHours(internalTheme.hoursTime)
    }

    return result
  }

  // Catalog mode
  if (!theme) return { controlQuestion: DEFAULT_CONTROL_QUESTION }

  const result: Partial<ThemeFormValues> = {
    title: theme.title,
    test: theme.test,
    controlQuestion: theme.controlQuestion ?? DEFAULT_CONTROL_QUESTION,
  }

  if (theme.courseTheme) {
    result.courseTheme = {
      ...theme.courseTheme,
      value: theme.courseTheme['@id'],
      label: theme.courseTheme.title,
    }
  }

  if (theme.hoursTime) {
    // Часы каталожной темы — целое число как есть (без ÷60): это поле отображения.
    result.hoursTime = String(theme.hoursTime)
  }

  return result
}

export default getDefaultValues
